import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { fetchRole, clearRole } from './roleSlice';

const initialState = {
  farmerInfo: null,      
  status: 'idle',       
  profileStatus: 'idle', 
  error: null,
  isLoggedIn: false, 
};

// --- 1. Farmer Login (Verify OTP) ---
export const login = createAsyncThunk(
  'farmer/login',
  async ({ base64PhoneAndOtp, description, otp }, { dispatch, rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        '/verifyOTP',
        { description, otp },
        {
          headers: {
            Authorization: base64PhoneAndOtp,
          },
        }
      );

      dispatch(fetchRole());
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Login Failed');
    }
  }
);

// --- 2. Fetch Farmer Profile ---
export const fetchFarmerProfile = createAsyncThunk(
  'farmer/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get('/user/info');
      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.msg || 'Failed to fetch profile');
    }
  }
);

// --- 3. Farmer Logout ---
export const logout = createAsyncThunk('farmer/logout', async (_, { dispatch }) => {
  try {
    const { data } = await axiosInstance.get('/logout'); 
    dispatch(clearRole());
    return data.msg;
  } catch (err) {
    dispatch(clearRole());
    return err.message;
  }
});

const farmerSlice = createSlice({
  name: 'farmer',
  initialState,
  reducers: {
    resetFarmerAuth: (state) => {
      state.isLoggedIn = false;
      state.farmerInfo = null;
      state.status = 'idle';
      state.profileStatus = 'idle';
      state.error = null;
    }
  },
  extraReducers(builder) {
    builder
      // --- Login Cases ---
      .addCase(login.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.isLoggedIn = true;
        state.farmerInfo = action.payload.data || action.payload; 
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        state.isLoggedIn = false;
      })
      .addCase(fetchRole.fulfilled, (state, action) => {
        if (action.payload.login_role === 'FARMER') {
          state.isLoggedIn = true;
          state.status = 'succeeded';
        }
      })
      .addCase(fetchFarmerProfile.fulfilled, (state, action) => {
        state.profileStatus = 'succeeded';
        state.farmerInfo = action.payload; 
      })
      
      // --- Logout Cases ---
      .addCase(logout.fulfilled, (state) => {
        state.status = 'succeeded';
        state.farmerInfo = null;
        state.isLoggedIn = false;
        state.profileStatus = 'idle';
      });
  },
});

export const { resetFarmerAuth } = farmerSlice.actions;
export default farmerSlice.reducer;